import { Clock, MapPin, Users, Music } from 'lucide-react'

const EventDetails = () => {
  const events = [
    {
      title: "Ceremony",
      time: "Promptly at 4:00 PM",
      location: "Big Red Barn",
      description: "Join us for our wedding ceremony in the rustic charm of the Big Red Barn.",
      icon: <Users className="w-8 h-8" />,
      details: [
        "Outdoor ceremony",
        "Rustic barn setting",
        "Unplugged ceremony - please no phones"
      ]
    },
    {
      title: "Cocktail Hour",
      location: "Barn Courtyard",
      description: "Celebrate with friends and family while we take photos.",
      icon: <Clock className="w-8 h-8" />,
      details: [
        "Hors d'Oeuvres",
        "Beer",
        "Wine",
        "Seltzers"
      ]
    },
    {
      title: "Reception",
      location: "Main Barn Hall",
      description: "Dinner, dancing, and celebration in the beautiful barn setting.",
      icon: <Music className="w-8 h-8" />,
      details: [
        "Buffet style dinner",
        "Limited bar",
        "Dancing until 8 PM"
      ]
    }
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Wedding Details
          </h2>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto">
            Join us for a day of love, laughter, and celebration. Here's everything you need to know about our special day.  While we would love everyone and their entire families to join us, it is necessary that we limit our event to adults only. 
            <br /><br />Please email or text us if you have specific questions.
          </p>
        </div>

        {/* Event Timeline */}
        <div className="space-y-12">
          {events.map((event, index) => (
            <div key={index} className="relative">
              {/* Timeline line */}
              {index < events.length - 1 && (
                <div className="absolute left-6 top-16 w-0.5 h-32 bg-sage-light/30 hidden md:block"></div>
              )}
              
              <div className="flex flex-col md:flex-row gap-8 items-start">
                {/* Icon */}
                <div className="flex-shrink-0 w-12 h-12 bg-sage-light text-white rounded-full flex items-center justify-center">
                  {event.icon}
                </div>
                
                {/* Content */}
                <div className="flex-1">
                  <div className="bg-cream/50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
                      <h3 className="font-serif text-2xl font-bold text-charcoal mb-2 lg:mb-0">
                        {event.title}
                      </h3>
                      <div className="flex items-center gap-4 text-sage-light font-medium">
                        <div className="flex items-center gap-2">
                          <Clock className="w-4 h-4" />
                          <span>{event.time}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <MapPin className="w-4 h-4" />
                          <span>{event.location}</span>
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-charcoal/80 mb-6 leading-relaxed">
                      {event.description}
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {event.details.map((detail, detailIndex) => (
                        <div key={detailIndex} className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-sage-light rounded-full"></div>
                          <span className="text-charcoal/70">{detail}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-rose-gold/10 rounded-2xl p-8 text-center">
          <h3 className="font-serif text-2xl font-bold text-charcoal mb-4">
            Important Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-charcoal/80">
            <div>
              <h4 className="font-semibold mb-2">Dress Code</h4>
              <p>Business casual suggested. Rustic barn elegant.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">Weather</h4>
              <p>Outdoor ceremony - please dress appropriately for the weather.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">Timeliness</h4>
              <p>We will be starting promptly at the scheduled time.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EventDetails
